import { Button } from "@mui/material"
import React from "react"
import { useAppSelector } from "../../../../../../app/hooks";
import { useCaseManStatusUpdateMutation } from "../../../../../../services/caseManService/caseManage-api";
import { CaseManStatusUpdateCommand } from "../../../../../../services/caseManService/commands";

function CodingPendBtn(){
    const caseManage = useAppSelector((state)=>state.caseManagement.caseManagement);
    const [saveStatus] = useCaseManStatusUpdateMutation();
    const handleSave=()=>{
        let command = new CaseManStatusUpdateCommand(caseManage,'Coding','Pending');
        saveStatus(command);
    }

    return <React.Fragment>
        <Button color='primary' variant='outlined'
            onClick={()=>handleSave()}
            disabled={caseManage.codingReviewStatus === 'Pending'}
        >PEND</Button>
    </React.Fragment>
}
export {CodingPendBtn}